var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUiWarningLtr = function SvgUiWarningLtr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49 62c-1.085 0-1.968-.924-2-2.077V33.14c0-1.182.895-2.14 2-2.14 1.085 0 1.968.924 2 2.077V59.86c0 1.182-.895 2.14-2 2.14m0 5a4 4 0 1 0 0 8 4 4 0 0 0 0-8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M58.85 15.46a11 11 0 0 0-3.959-3.96c-5.247-3.06-11.983-1.288-15.044 3.96L6.498 72.627A11 11 0 0 0 5 78.171c0 6.075 4.925 11 11 11h66.697a11 11 0 0 0 5.543-1.499c5.247-3.06 7.02-9.796 3.959-15.044zm-13.7 2.826a5 5 0 0 1 6.718-1.604l.244.152a5 5 0 0 1 1.555 1.648l33.35 57.168.11.2a5 5 0 0 1-4.43 7.32H16l-.217-.005a5 5 0 0 1-4.102-7.515L45.03 18.481z",
    clipRule: "evenodd"
  })));
};
export default SvgUiWarningLtr;